/*
 * PanamaJack — Evita el scroll-al-top al clicar las flechas del carrusel de galeria.
 *
 * Bug pre-existente (6.0.0 y 10.2.0): las flechas prev/next de la galeria del
 * producto (featured-product / main-product) y del carrusel de productos
 * complementarios son <a href="#">. Swiper 4.3.3 cambia el slide por su propio
 * manejo de punteros, pero NO llama preventDefault() en el click del <a>, asi
 * que el navegador sigue el fragmento "#" y salta al top de la pagina.
 *
 * Fix: un unico handler delegado en document que hace preventDefault() en el
 * click de estas flechas. La delegacion sobrevive a las re-render del vendor
 * (Swiper recrea/recicla los nodos) sin re-cablear nada. NO toca el cambio de
 * slide: Swiper ya ha actuado; solo se cancela la navegacion por defecto del <a>.
 *
 * Vanilla JS, sin dependencias. Carga con defer desde layout/theme.liquid.
 */
(function () {
  var ARROW_SELECTOR =
    ".swiper-button-prev, .swiper-button-next, .js-swiper-button-prev, .js-swiper-button-next";

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") {
        return;
      }
      var arrow = target.closest(ARROW_SELECTOR);
      if (!arrow) {
        return;
      }
      // Solo flechas que naveguen a un fragmento vacio (href="#"); deja pasar
      // cualquier <a> con destino real por si acaso.
      var href = arrow.getAttribute("href");
      if (href === "#" || href === "" || href === null) {
        event.preventDefault();
      }
    },
    false
  );
})();
